import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import {
  updateCategory,
  deleteCategory,
  insertCategory,
  uploadObjectS3,
  deleteObjectS3,
  updatePriority,
  updateS3FileName,
} from "../../../../helper";
import { FaTrashAlt } from "react-icons/fa";
import "./styles.scss";
import ChooseImage from "../ChooseImage/index";
import { getImagePreview } from "../../../../components/helper";

export default function Categories(props) {
  const [databaseUpdateEnabled, setDatabaseUpdateEnabled] = useState(false);
  const {
    category,
    deteleEmptyCategory,
    fetchCategories,
    categoriesLength,
  } = props;
  var {
    category_id,
    category_name,
    category_description,
    image_src,
  } = category;

  const [nameInput, setNameInput] = useState(category_name);
  const [descriptionInput, setDescriptionInput] = useState(
    category_description
  );
  const [changeImage, setChangeImage] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [priority, setPriority] = useState(category.priority);
  const [updateImage, setUpdateImage] = useState(false);

  const isDataBaseUpdateEnabled = useCallback(
    () =>
      category_name === nameInput && category_description === descriptionInput
        ? setDatabaseUpdateEnabled(false)
        : setDatabaseUpdateEnabled(true),
    [category_description, category_name, descriptionInput, nameInput]
  );

  useEffect(() => {
    isDataBaseUpdateEnabled();
    if (updateImage) {
      setTimeout(() => {
        setUpdateImage(false);
        setImageFile(null);
      }, 5000);
    }
  }, [updateImage, isDataBaseUpdateEnabled]);

  return (
    <Row className="mb-5">
      <Col sm={1}>
        <Form.Group>
          <Form.Control
            type="number"
            placeholder="Category Priority"
            value={priority}
            onChange={async (event) =>
              Number(event.target.value) > 0 &&
              Number(event.target.value) <= categoriesLength
                ? setPriority(event.target.value)
                : setPriority(category.priority)
            }
          />
        </Form.Group>
      </Col>
      <Col sm={3}>
        <Form.Group>
          <Form.Control
            type="text"
            placeholder="Category Name"
            value={nameInput || ""}
            onChange={async (event) =>
              setNameInput(
                event.target.value === "" ? null : event.target.value
              )
            }
          />
        </Form.Group>
      </Col>
      <Col sm={6}>
        <Form.Group>
          <Form.Control
            type="text"
            placeholder="Category Description"
            value={descriptionInput || ""}
            onChange={(event) => setDescriptionInput(event.target.value)}
          />
        </Form.Group>
      </Col>
      <Col>{getImagePreview(imageFile, image_src, updateImage)}</Col>
      <Col>
        <Button onClick={() => setChangeImage(!changeImage)}>
          {`${
            image_src === null && imageFile === null ? "Add" : "Change"
          } Image`}
        </Button>
      </Col>
      {imageFile && (
        <Col>
          <Button onClick={() => setImageFile(null)}>Cancel Image</Button>
        </Col>
      )}
      <Col sm={1} className="mb-1 mt-3">
        <Button
          disabled={
            !databaseUpdateEnabled &&
            category.priority === priority &&
            !imageFile
          }
          className="mb-1"
          onClick={async () => {
            if (category_id) {
              if (priority !== category.priority) {
                updatePriority(category_id, priority)
                  .then(() => alert("Priority Updated Successfully"))
                  .then(async () => await fetchCategories())
                  .catch(() => alert("Priority Update Failed"));
              }
              if (databaseUpdateEnabled) {
                const newImageSource = `categories/${nameInput
                  .toLowerCase()
                  .replace(/ /g, "_")}.jpg`;
                await updateCategory(category_id, {
                  category_description: descriptionInput,
                  category_name: nameInput,
                  image_src: newImageSource,
                }).then(async (removeRow) => {
                  setDatabaseUpdateEnabled(false);
                  if (removeRow) {
                    if (nameInput !== category_name) {
                      await updateS3FileName(image_src, newImageSource);
                    }
                  }
                  await fetchCategories();
                });
              }
            } else {
              if (nameInput !== null && imageFile !== null) {
                image_src = `categories/${nameInput
                  .toLowerCase()
                  .replace(/ /g, "_")}.jpg`;
                insertCategory({
                  category_name: nameInput,
                  category_description: descriptionInput,
                  image_src,
                }).then(async () => await fetchCategories());
              } else if (!nameInput) {
                alert("Name cannot be null");
              } else {
                alert("Please upload category image");
              }
            }
            if (imageFile) {
              await uploadObjectS3(image_src, imageFile).then(() => {
                setImageFile(null);
                setChangeImage(false);
                setUpdateImage(true);
              });
            }
          }}
        >
          {category_id === null ? "Insert" : "Update"}
        </Button>
        <FaTrashAlt
          className="ml-1"
          size={25}
          onClick={() => {
            category_id
              ? deleteCategory(category_id, category_name).then(
                  async (removeRow) => {
                    if (removeRow) {
                      await deleteObjectS3(image_src)
                        .then(() => alert("Category deleted successfully"))
                        .then(async () => await fetchCategories());
                    }
                  }
                )
              : deteleEmptyCategory();
          }}
        />
      </Col>
      <ChooseImage
        show={changeImage}
        setImageFile={setImageFile}
        imageFile={imageFile}
        onClose={() => setChangeImage(false)}
      />
    </Row>
  );
}
